import { queryKeys } from "../queryKeys";
import { getMargin, type Margin } from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

// @todo this hook will be short lived (when we refactor the entire app)
export const useGetBalances = ({
  accountID,
  paper,
  options,
}: {
  accountID: string;
  paper?: boolean;
  options?: QueryOptions<{ current?: Margin | null; last?: Margin | null }>;
}) => {
  const response = useRequest(
    queryKeys.balances.list(accountID, paper),
    async () => {
      const [current, last] = await Promise.all([
        getMargin(accountID, paper),
        getMargin(accountID, paper, true),
      ]);

      return { last, current };
    },
    {
      ...options,
      staleTime: -1,
    },
  );

  return response;
};
